import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
const gameVuex = createNamespacedHelpers("game");
export default {
  name: "index",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "settingInfo"]),
    ...walletVuex.mapState(["isMobile"]),
    multipleSelected() {
      return this.selectRow.multiplierInfo?.filter(itm => itm.multiple == this.selectRow.user_prediction_dto?.multiple)?.[0]?.multiple;
    }
  },
  data() {
    const tabList = [{
      label: "All",
      value: 0,
      tag: 0
    }, {
      label: "History",
      value: 2,
      tag: 0
    }, {
      label: "Payout",
      value: 1,
      tag: 0
    }];
    return {
      tabList,
      selectTab: null,
      popConfirmChoiceShow: false,
      popMarkeChoiceShow: false,
      activityList: null,
      payoutList: null,
      historyList: null,
      calcListTimer: null,
      popPartnerInfoShow: false,
      selectRow: null,
      selectMultiplier: null,
      choiceLoading: false,
      submitLoading: false,
      popCollectPayoutShow: false,
      selectCollectPayoutRow: null,
      popCollectPayoutConfirmIsLoading: false,
      listPage: {
        total: 0,
        page: 0,
        pageSize: 5
      },
      isLoading: false,
      isFinished: false,
      historyListPage: {
        total: 0,
        page: 0,
        pageSize: 5
      },
      isHistoryLoading: false,
      isHistoryFinished: false,
      popIndexItemShareShow: false,
      selectItemShareRow: null
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          await this.initFn();
          const payoutInfo = await this.getPartyActivityList({
            status: 0
          });
          this.listPage.total = payoutInfo.total;
          console.log("this.listPage.total", this.listPage.total);
          this.tabList[2].tag = this.listPage.total;
          window.addEventListener("scroll", this.handleScroll.bind(this));
        }
      },
      deep: true,
      immediate: true
    },
    selectTab(val) {
      this.initFn();
    }
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleScroll);
    setTimeout(() => {
      next();
    }, 100);
  },
  methods: {
    ...gameVuex.mapActions(["getActivityList", "getPartyActivityList", "getHistoryActivityList", "getActivitySubmit", "activityClaim"]),
    ...userVuex.mapActions(["openInvoiceStarPay", "paymentDepositStars", "checkPaymentStars"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    isVailYoutube(url) {
      if (typeof url !== "string") return false;
      const keywords = ["youtube", "youtu.be", "youtube-nocookie", "music.youtube"];
      return keywords.some(kw => url.toLowerCase().includes(kw));
    },
    linkifyForTelegramSafe(text) {
      const urlRegex = /(https?:\/\/[^\s)]+)/g;
      return text.replace(urlRegex, url => {
        const safeUrl = url.replace(/"/g, "&quot;"); // 防止属性注入
        return `<span class="tg-link" data-url="${safeUrl}" style="color: #929daa; text-decoration: underline;cursor: pointer;">${safeUrl}</span>`;
      });
    },
    handleLinkClick(e) {
      const target = e.target;
      if (target && target.classList.contains('tg-link')) {
        const url = target.getAttribute('data-url');
        if (url && Telegram?.WebApp?.openLink) {
          Telegram.WebApp.openLink(url);
        }
      }
    },
    showPop(item) {
      if (item.status === 1) {
        if (JSON.stringify(item.user_prediction_dto) == "{}") {
          this.selectRow = {
            ...item,
            isUserChoice: null,
            isUserTicket: false,
            showChoiceBtn: true
          };
          this.selectMultiplier = this.selectRow.multiplierInfo[this.selectRow.default_multiple_index];
          if (item.partnerInfo.buttonUrl) {
            this.popPartnerInfoShow = true;
          } else {
            this.popMarkeChoiceShow = true;
          }
        } else {
          this.selectRow = {
            ...item,
            isUserChoice: true,
            isUserTicket: true,
            showChoiceBtn: true
          };
          this.selectMultiplier = this.selectRow.multiplierInfo[this.selectRow.default_multiple_index];
          if (item.partnerInfo.buttonUrl) {
            this.popPartnerInfoShow = true;
          } else {
            this.popMarkeChoiceShow = true;
          }
        }
      } else if (item.status === 2) {
        if (this.selectTab.value === 1) {
          this.selectCollectPayoutRow = {
            event_id: item.user_prediction_dto.event_id,
            reward_coin: item.user_prediction_dto.reward_coin,
            reward_ticket: item.user_prediction_dto.reward_ticket,
            is_win: item.user_prediction_dto.is_win,
            choice: item.user_prediction_dto.choice,
            icon: item.icon,
            status: item.user_prediction_dto.status
          };
          console.log("this.selectCollectPayoutRow", this.selectCollectPayoutRow);
          this.popCollectPayoutShow = true;
        } else {
          this.selectRow = {
            ...item,
            isUserChoice: null,
            isUserTicket: JSON.stringify(item.user_prediction_dto) == "{}" ? false : true,
            showChoiceBtn: false
          };
          this.selectMultiplier = this.selectRow.multiplierInfo[this.selectRow.default_multiple_index];
          if (item.partnerInfo.buttonUrl) {
            this.popPartnerInfoShow = true;
          } else {
            this.popMarkeChoiceShow = true;
          }
        }
      }
    },
    onPartnerInfoOpen() {
      this.popMarkeChoiceShow = true;
    },
    onPartnerInfoVote() {
      const regex = /^https?:\/\/t\.me\//;
      const url = this.selectRow.partnerInfo.buttonUrl;
      const bool = regex.test(url);
      console.log("boolboolboolbool", bool);
      if (regex.test(url)) {
        this.WebApp.openTelegramLink(url);
      } else {
        this.WebApp.openLink(url);
      }
    },
    onSliderSelect(val) {
      this.selectMultiplier = val;
    },
    async popMarkeChoiceConfirm(type) {
      if (!this.selectMultiplier) {
        return;
      }
      this.choiceLoading = true;
      if (this.userInfo.ticket < this.selectRow.ticket_cost) {
        this.choiceLoading = false;
        console.log("this.$refs.mHeadRef", this.$refs.mHeadRef);
        this.$refs.mHeadRef.popEarnTicketShow = true;
        return;
      }
      if (this.userInfo.stars < this.selectMultiplier.stars) {
        const res = await this.paymentStars(this.selectMultiplier.stars - this.userInfo.stars);
        if (!res) {
          this.choiceLoading = false;
          return;
        }
      }
      this.choiceLoading = false;
      this.selectRow.isUserChoice = type;
      this.popMarkeChoiceShow = false;
      // this.popPartnerInfoShow = false;
      this.popConfirmChoiceShow = true;
    },
    async onConfirmChoice() {
      this.submitLoading = true;
      const params = {
        eventId: this.selectRow.id,
        choice: this.selectRow.isUserChoice,
        multiple: this.selectMultiplier.multiple
      };
      const res = await this.getActivitySubmit(params);
      if (!res) {
        this.submitLoading = false;
        return;
      }
      this.selectRow.isUserTicket = true;
      const eventInfo = res.eventInfo;
      this.selectRow = {
        ...res.eventInfo,
        isUserTicket: true
      };
      const index = this.activityList.findIndex(item => item.id == eventInfo.id);
      this.activityList[index] = eventInfo;
      this.setUserInfo(res.userInfo);
      this.popMarkeChoiceShow = true;
      this.submitLoading = false;
      this.$toasted.clear();
      this.$toasted.success(`Successfully obtained ${this.fmt_pre(eventInfo.instant_reward)} sees rewards!`);
      this.popConfirmChoiceShow = false;
      this.setConfetti();
    },
    //余额不足 支付星星
    async paymentStars(amount) {
      return new Promise(async resolve => {
        const res = await this.paymentDepositStars({
          amount
        });
        if (!res) {
          this.choiceLoading = false;
          resolve();
          return;
        }
        const chainInfo = res.chainInfo;
        console.log("chainInfo", chainInfo);
        const starPayRef = await this.openInvoiceStarPay({
          url: chainInfo.payment_url
        });
        if (!starPayRef) {
          this.choiceLoading = false;
          resolve();
          return;
        }
        const checkRes = await this.checkPaymentStars({
          order_id: chainInfo.order_id
        });
        console.log("checkRescheckRescheckRes", checkRes);
        if (!checkRes) {
          this.choiceLoading = false;
          return;
        }
        resolve(1);
      });
    },
    setConfetti() {
      this.confetti({
        particleCount: 15,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        zIndex: 2000
      });
      this.confetti({
        particleCount: 15,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        zIndex: 2000
      });
    },
    async initFn() {
      if (this.selectTab) {
        if (this.selectTab.value == 0) {
          this.activityList = await this.getActivityList();
        } else if (this.selectTab.value == 1) {
          this.getListInfoFunc(false);
        } else if (this.selectTab.value == 2) {
          this.getHistoryListInfoFunc(false);
        }
      }
    },
    onShareShow(item) {
      this.selectItemShareRow = item;
      this.popIndexItemShareShow = true;
    },
    showPopCollectPayoutShow(item) {
      this.selectCollectPayoutRow = {
        event_id: item.event_id,
        reward_coin: item.reward_coin,
        reward_ticket: item.reward_ticket,
        is_win: item.is_win,
        choice: item.choice,
        icon: item.icon,
        status: item.status
      };
      console.log("popCollectPayoutShow", this.popCollectPayoutShow);
      this.popCollectPayoutShow = true;
    },
    async popCollectPayoutConfirm(item) {
      this.popCollectPayoutConfirmIsLoading = true;
      console.log("item", this.selectCollectPayoutRow);
      const res = await this.activityClaim({
        eventId: this.selectCollectPayoutRow.event_id
      });
      if (!res) {
        this.popCollectPayoutConfirmIsLoading = false;
        return;
      }
      this.setUserInfo(res.userInfo);
      await this.initFn();
      this.$toasted.success("claim success!");
      this.popCollectPayoutShow = false;
      this.popCollectPayoutConfirmIsLoading = false;
    },
    async getListInfoFunc(isPage) {
      this.listPage.page++;
      if (!isPage) {
        if (this.selectTab.value == 1) {
          this.payoutList = null;
        }
        this.listPage.page = 1;
      }
      const params = {
        page: this.listPage.page,
        pageSize: this.listPage.pageSize
      };
      this.isLoading = true;
      const res = await this.getPartyActivityList({
        status: 0,
        ...params
      });
      if (!res) {
        this.isLoading = false;
        return;
      }
      this.listPage.total = res.total;
      this.tabList[2].tag = this.listPage.total;
      if (this.selectTab.value == 1) {
        if (this.payoutList === null) {
          this.payoutList = [];
        }
        this.payoutList.push(...res.items);
        this.isFinished = this.payoutList.length >= this.listPage.total; // 没有更多数据
      }

      this.isLoading = false;
    },
    async getHistoryListInfoFunc(isPage) {
      this.historyListPage.page++;
      if (!isPage) {
        if (this.selectTab.value == 2) {
          this.historyList = null;
        }
        this.historyListPage.page = 1;
      }
      const params = {
        page: this.historyListPage.page,
        pageSize: this.historyListPage.pageSize
      };
      this.isHistoryLoading = true;
      const res = await this.getHistoryActivityList({
        ...params
      });
      if (!res) {
        this.isHistoryLoading = false;
        return;
      }
      this.historyListPage.total = res.total;
      // this.tabList[2].tag = this.historyListPage.total;
      if (this.selectTab.value == 2) {
        if (this.historyList === null) {
          this.historyList = [];
        }
        this.historyList.push(...res.items);
        this.isHistoryFinished = this.historyList.length >= this.historyListPage.total; // 没有更多数据
      }

      this.isHistoryLoading = false;
    },
    async handleScroll() {
      if (this.selectTab.value == 1 && (this.isLoading || this.isFinished)) return;
      if (this.selectTab.value == 2 && (this.isHistoryLoading || this.isHistoryFinished)) return;
      // 获取页面滚动的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 判断是否接近页面底部（距离底部100px以内时触发加载更多）
      if (scrollTop + windowHeight + 1 >= documentHeight) {
        if (this.selectTab.value == 1) {
          await this.getListInfoFunc(true);
        } else if (this.selectTab.value == 2) {
          await this.getHistoryListInfoFunc(true);
        }
      }
    },
    onYoutube(item) {
      const url = item.partnerInfo.buttonUrl;
      this.WebApp.openLink(url);
    },
    onShare() {
      const item = this.selectItemShareRow;
      this.hapticFeedback();
      const defaultContent = `✅Here, your judgment turns into real rewards.
💥Go bold and claim up to 100x returns!💸`;
      let url = null;
      if (!item.share_txt) {
        url = `https://t.me/share/url?text=${encodeURIComponent(defaultContent)}&url=https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}`;
      } else {
        url = `https://t.me/share/url?text=${encodeURIComponent(item.share_txt)}&url=https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}`;
      }
      this.WebApp.openTelegramLink(url);
    },
    onCopy() {
      const item = this.selectItemShareRow;
      this.hapticFeedback();
      const defaultContent = `✅Here, your judgment turns into real rewards.
💥Go bold and claim up to 100x returns!💸`;
      const content = !item.share_txt ? defaultContent : item.share_txt;
      const that = this;
      const url = `https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}\n${content}`;
      this.$copyText(url).then(function (e) {
        that.$toasted.clear();
        that.$toasted.success(that.$lang("Copy Success!"));
      }, function (e) {});
    }
  },
  mounted() {
    document.addEventListener('click', this.handleLinkClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleLinkClick);
  }
};